import SingleItemDisplay from "../../../../../images/checkout/single-item-display.svg";
import MultipleItemsSelectone from "../../../../../images/checkout/multiple-items-select-one.svg";
import SingleItemMultiplePrices from "../../../../../images/checkout/single-item-multiple-prices.svg";
import MultipleItemsAllIncluded from "../../../../../images/checkout/multiple-items-all-included.svg";
import ActiveSingleItemDisplay from "../../../../../images/checkout/single-item-display-active.svg";
import ActiveMultipleItemsSelectone from "../../../../../images/checkout/multiple-items-select-one-active.svg";
import ActiveSingleItemMultiplePrices from "../../../../../images/checkout/single-item-multiple-prices-active.svg";
import ActiveMultipleItemsAllIncluded from "../../../../../images/checkout/multiple-items-all-included-active.svg";
import SingleItemIcon from "../../../../../images/sidebar/item-details-blue-grey.svg";
import MultipleItemIcon from "../../../../../images/sidebar/item-details-logo.svg";
import OtherThanDonationItem from "../../../../../images/checkout/OtherThanDonation.svg";
import BasicIcon from "../../../../../images/checkout/basic-icon.svg";
import CustomIcon from "../../../../../images/checkout/custom-icon.svg";
import DonationIcon from "../../../../../images/donation/donating-hands.svg";
import DonationCardIcon from "../../../../../images/checkout/donation-card.svg";
import ActiveDonationCardIcon from "../../../../../images/checkout/active-donation-card.svg";
import { CheckoutColorType, CheckOutDisplayTypes } from "../enums";
import { IOption } from "@mindmemobile/mm-shared-global";
import { ColorModel, RGBA } from "./ProductModel";

type DisplayItem = {
  key: string;
  label: string;
  icon: string;
};

export const displays: DisplayItem[] = [
  { key: "single", label: "Single Item / Price", icon: SingleItemIcon },
  { key: "multiple", label: "Multiple Items / Prices", icon: MultipleItemIcon },
];

export const checkoutItemsType: DisplayItem[] = [
  {
    key: "noDonation",
    label: "Product, Service or Membership",
    icon: OtherThanDonationItem,
  },
  { key: "onlyDonation", label: "Donation Only", icon: DonationIcon },
];

export interface DisplayCard {
  image: string;
  label1: string;
  label2: string;
  label3: string;
  id: keyof typeof CheckOutDisplayTypes;
  isDonationOnly?: boolean;
  activeImage: string;
}

export const displayCardData: { [key: string]: DisplayCard[] } = {
  single: [
    {
      image: SingleItemDisplay,
      label1: "Single Item & Price",
      label2: "Sell a Product, Service or",
      label3: "Membership.",
      id: CheckOutDisplayTypes.SingleItem,
      activeImage: ActiveSingleItemDisplay,
    },
  ],
  multiple: [
    {
      image: SingleItemMultiplePrices,
      label1: "Single Item / Multiple Prices",
      label2: "Sell a Service or Membership with multiple",
      label3: "prices. Customer chooses one price",
      id: CheckOutDisplayTypes.SingleItemWithMultiplePrices,
      activeImage: ActiveSingleItemMultiplePrices,
    },
    {
      image: DonationCardIcon,
      label1: "Donation",
      label2: "Collect a Donation Once or",
      label3: "Monthly",
      isDonationOnly: true,
      id: CheckOutDisplayTypes.SingleItem,
      activeImage: ActiveDonationCardIcon,
    },
    {
      image: MultipleItemsSelectone,
      label1: "Multiple Items",
      label2: "Sell multiple Products, Services or",
      label3: "Memberships. Customer buys one.",
      id: CheckOutDisplayTypes.MultipleItems,
      activeImage: ActiveMultipleItemsSelectone,
    },
    {
      image: MultipleItemsAllIncluded,
      label1: "Multiple Items in a Bundle",
      label2: "Combine multiple Products, Services or ",
      label3: "Memberships. Customer buys all.",
      id: CheckOutDisplayTypes.MultipleItemsInbundle,
      activeImage: ActiveMultipleItemsAllIncluded,
    },
  ],
};

export const sampleAccounts: IOption[] = [
  {
    label: "School Revenue Account",
    value: "School Operating Account Chase Bank ending in 0322 United States",
  },
  {
    label: "Prasanna Merchant Account",
    value: "Prasanna Operating Account is currently running in United States",
  },
];

export const samplePaymentMethodsRaw: string[] = [
  "Phonepay",
  "GooglePay",
  "Credit/Debit Card",
  "Bank",
];
export const samplePaymentMethods: string[] = [
  "Phonepay",
  "GooglePay",
  "Credit/Debit Card",
  "Bank",
];

export const sampleContacts: IOption[] = [];

export const mainColorPickerElements = [
  {
    name: "Primary",
    color: new ColorModel({
      hex: "#68C598",
      rgba: "rgba(104, 197, 152, 1)",
      rgbValue: new RGBA({ r: "104", g: "197", b: "152", a: "1" }),
    }),
    showColorPicker: false,
  },
  {
    name: "Tabs",
    color: new ColorModel({
      hex: "#EDA211",
      rgba: "rgba(237, 162, 17, 1)",
      rgbValue: new RGBA({ r: "237", g: "162", b: "17", a: "1" }),
    }),
    showColorPicker: false,
  },
  {
    name: "Recommended",
    color: new ColorModel({
      hex: "#555555",
      rgba: "rgba(85, 85, 85, 1)",
      rgbValue: new RGBA({ r: "85", g: "85", b: "85", a: "1" }),
    }),
    showColorPicker: false,
  },
];

export const donationMainColors = [
  {
    name: "Primary",
    color: new ColorModel({
      hex: "#2c3e50",
      rgba: "rgba(44, 62, 80)",
      rgbValue: new RGBA({ r: "44", g: "62", b: "80", a: "1" }),
    }),
    showColorPicker: false,
  },
  {
    name: "Secondary",
    color: new ColorModel({
      hex: "#E7E9EC",
      rgba: "rgba(231, 233, 236)",
      rgbValue: new RGBA({ r: "231", g: "233", b: "236", a: "1" }),
    }),
    showColorPicker: false,
  },
];

export const bgColorPickerElements = [
  {
    name: "Inner",
    color: new ColorModel({
      hex: "#FFFFFF",
      rgba: "rgba(255, 255, 255, 1)",
      rgbValue: new RGBA({ r: "255", g: "255", b: "255", a: "1" }),
    }),
    showColorPicker: false,
  },
  {
    name: "Outer",
    color: new ColorModel({
      hex: "#FFFFFF",
      rgba: "rgba(255, 255, 255, 1)",
      rgbValue: new RGBA({ r: "255", g: "255", b: "255", a: "1" }),
    }),
    showColorPicker: false,
  },
  {
    name: "Page",
    color: new ColorModel({
      hex: "#FFFFFF",
      rgba: "rgba(255, 255, 255, 1)",
      rgbValue: new RGBA({ r: "255", g: "255", b: "255", a: "1" }),
    }),
    showColorPicker: false,
  },
];

export const donationBgColors = [
  {
    name: "Inner",
    color: new ColorModel({
      hex: "#FFFFFF",
      rgba: "rgba(255, 255, 255, 1)",
      rgbValue: new RGBA({ r: "255", g: "255", b: "255", a: "1" }),
    }),
    showColorPicker: false,
  },
  {
    name: "Page",
    color: new ColorModel({
      hex: "#FFFFFF",
      rgba: "rgba(255, 255, 255, 1)",
      rgbValue: new RGBA({ r: "255", g: "255", b: "255", a: "1" }),
    }),
    showColorPicker: false,
  },
];

export const borderColorPickerElements = [
  {
    name: "Inner",
    color: new ColorModel({
      hex: "#68C598",
      rgba: "rgba(104, 197, 152, 1)",
      rgbValue: new RGBA({ r: "104", g: "197", b: "152", a: "1" }),
    }),
    showColorPicker: false,
  },
  {
    name: "Outer",
    color: new ColorModel({
      hex: "#CCCCCC",
      rgba: "rgba(204, 204, 204, 1)",
      rgbValue: new RGBA({ r: "204", g: "204", b: "204", a: "1" }),
    }),
    showColorPicker: false,
  },
];

export const donationBorderColors = [
  {
    name: "Inner",
    color: new ColorModel({
      hex: "#68C598",
      rgba: "rgba(104, 197, 152, 1)",
      rgbValue: new RGBA({ r: "104", g: "197", b: "152", a: "1" }),
    }),
    showColorPicker: false,
  },
];

export const donationFontColors = [
  {
    name: "Default",
    color: new ColorModel({
      hex: "#555555",
      rgba: "rgba(85, 85, 85, 1)",
      rgbValue: new RGBA({ r: "85", g: "85", b: "85", a: "1" }),
    }),
    showColorPicker: false,
  },
  {
    name: "Active Button",
    color: new ColorModel({
      hex: "#FFFFFF",
      rgba: "rgba(255, 255, 255, 1)",
      rgbValue: new RGBA({ r: "255", g: "255", b: "255", a: "1" }),
    }),
    showColorPicker: false,
  },
  {
    name: "Muted Button",
    color: new ColorModel({
      hex: "#555555",
      rgba: "rgba(85, 85, 85, 1)",
      rgbValue: new RGBA({ r: "85", g: "85", b: "85", a: "1" }),
    }),
    showColorPicker: false,
  },
];

export const progressColorPickerElements = [
  {
    name: "Selected Bar",
    color: new ColorModel({
      hex: "#FF0000",
      rgba: "rgba(255, 0, 0, 1)",
      rgbValue: new RGBA({ r: "255", g: "0", b: "0", a: "1" }),
    }),
    showColorPicker: false,
  },
  {
    name: "Unselected Bar",
    color: new ColorModel({
      hex: "#DDDDDD",
      rgba: "rgba(221, 221, 221, 1)",
      rgbValue: new RGBA({ r: "221", g: "221", b: "221", a: "1" }),
    }),
    showColorPicker: false,
  },
];

export const basicColorPickerElements = [
  {
    name: "Primary",
    color: new ColorModel({
      hex: "#68C598",
      rgba: "rgba(104, 197, 152, 1)",
      rgbValue: new RGBA({ r: "104", g: "197", b: "152", a: "1" }),
    }),
    showColorPicker: false,
  },
  {
    name: "Tabs",
    color: new ColorModel({
      hex: "#EDA211",
      rgba: "rgba(237, 162, 17, 1)",
      rgbValue: new RGBA({ r: "237", g: "162", b: "17", a: "1" }),
    }),
    showColorPicker: false,
  },
  {
    name: "Recommended",
    color: new ColorModel({
      hex: "#555555",
      rgba: "rgba(85, 85, 85, 1)",
      rgbValue: new RGBA({ r: "85", g: "85", b: "85", a: "1" }),
    }),
    showColorPicker: false,
  },
  { name: "Page Background", color: null, showColorPicker: false },
];

export const colorTypes = [
  { icon: BasicIcon, name: CheckoutColorType.BasicColor },
  { icon: CustomIcon, name: CheckoutColorType.CustomColor },
];
